export const SSN_ITIN_REGEX = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
export const EIN_REGEX = /^[0-9]{2}-[0-9]{7}$/;
export const SSN_REGEX = /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/;
export const ITIN_REGEX = /^9\d{2}-[7-8]\d-\d{4}$/;
export const FOREIGN_TAX_ID_REGEX = /^[A-Za-z0-9]{6,20}$/;
export const FOREIGN_PASSPORT_REGEX = /^[A-Za-z0-9]{6,9}$/;
export const FOREIGN_ENTITY_REGISTRATION_REGEX = /^[A-Za-z0-9]{5,20}$/;

export const US_POSTAL_CODE_REGEX = /(^$|^\b\d{5}(-\d{4})?\b$)/;

export const PHONE_NUMBER_REGEX = /^\d{3}-\d{3}-\d{4}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
